export type { BoxAttachment, BoxFolder, BoxKey, BoxMail, BoxThreadMsg } from './types';
export { ATT_MB, BOX_NOW, MAILS, THREADS } from './fixtures';
export { mailsOf, openCount, threadOf, unreadCount } from './logic';

import { MAILS } from './fixtures';

/** Nạp dữ liệu mẫu Box: `fixtures: registerBoxFixtures` của zone. */
export function registerBoxFixtures(register: (entity: string, rows: readonly unknown[]) => void): void {
  register('boxMail', MAILS);
}
export { loadInbox, mailFromGraph, maskAddr, setBoxGraph, type BoxGraph, type GraphMailSummary, type MailLoad } from './graphMail';
